import {
  createAsyncThunk,
  createReducer,
  isFulfilled,
  isPending,
  isRejected,
} from "@reduxjs/toolkit";
import AssinanteService from "../../sdk/services/AssinanteService";
import { Assinante } from "../../sdk/@types/Assinante";

interface AssinanteState {
  assinante: Assinante.Assinante | null;
  assinatura: Assinante.Assinante | null;
  list: Assinante.Assinante[];
  fetching: boolean;
}

const initialState: AssinanteState = {
  assinante: null,
  assinatura: null,
  list: [],
  fetching: false,
};

// Updated thunk to use AssinanteService and subscribers endpoint
export const getAssinantes = createAsyncThunk(
  "assinante/getAssinantes",
  async () => await AssinanteService.getAssinantes(),
);

export const getAssinatura = createAsyncThunk(
  "assinante/getAssinatura",
  async () => await AssinanteService.getAssinatura(),
);

export default createReducer(initialState, (builder) => {
  const success = isFulfilled(getAssinantes);
  const error = isRejected(getAssinantes);
  const loading = isPending(getAssinantes);

  builder
    .addCase(getAssinantes.fulfilled, (state, action) => {
      state.list = action.payload;
    })
    .addCase(getAssinatura.fulfilled, (state, action) => {
      debugger;
      state.assinatura = action.payload;
    })
    .addMatcher(success, (state) => {
      state.fetching = false;
    })
    .addMatcher(error, (state) => {
      state.fetching = false;
    })
    .addMatcher(loading, (state) => {
      state.fetching = true;
    });
});
